<h1 id="get-started-heading" class="sr-only" tabindex="-1" aria-hidden="false">Get Started</h1>

<div>
  <p class="mb-2 font-bold" role="heading" aria-level="2">
    BEFORE YOU START
  </p>

  <p>Before you begin the registration process, be aware of the items below:</p>

  <ul class="list-disc my-4 ps-8">
    <li>
      Each person in your office who will be using the portal should
      register their own account. Users should not share
      portal accounts.
    </li>
    <li>
      For providers, you will need to enter the <span class="p-error">10-digit NPI.</span>
    </li>
    <li>
      For providers only, you will also need to enter your <span class="p-error">Tax ID.</span>
    </li>
    <li>
      You will need to provide your preferred business email address.<span class="p-error"> (No duplicates allowed)</span>
    </li>
    <li>
      You will need to provide your preferred business phone number and fax number.
    </li>
  </ul>

  <hr class="my-4">

  <p class="font-bold" role="heading" aria-level="2">TO REGISTER</p>

  <ul class="list-disc my-4 ps-8">
    <li>'Accept' Agree to Terms.</li>
    <li>Click 'Begin' to start.</li>
    <li>Click the “Provider Type” dropdown and select your provider type.</li>
    <li>For Providers - Enter your <span class="p-error"> organization's 10-digit NPI </span>
       in the “Provider NPI” field. The portal displays providers that match your entry.
    </li>
    <li>If you cannot find your organization, you will need to call Carelon &#64; 1-844-411-9622 option 4 for assistance.</li>
    <li>Select your organization.</li>
    <li>Complete the other fields on the page then click Continue and Submit button.</li>
  </ul>

  <hr class="my-4">

  <p role="heading" aria-level="2">TERMS OF USE</p>

  <ul class="list-disc my-4 ps-8">
    <li>By Selecting "Accept" below you agree to the
      <a [href]="privacyPolicyTermsOfUse" target="_blank" class="no-underline p-button-link">Privacy Policy & Terms of use.</a>
    </li>
  </ul>

  <div class="flex gap-4 ml-12">
    <div class="flex gap-2">
      <p-radioButton inputId="accept_input" name="accept" [value]="true" [(ngModel)]="isAcceptTermsOfUse" />
      <label for="accept_input">Accept</label>
    </div>
    <div class="flex gap-2">
      <p-radioButton inputId="decline_input" name="decline" [value]="false" [(ngModel)]="isAcceptTermsOfUse" />
      <label for="decline_input">Decline</label>
    </div>
  </div>
  <div class="flex justify-end">
    <button pButton label="Begin" type="button" class="p-button-warning" [disabled]="!isAcceptTermsOfUse" (click)="begin()">
    </button>
  </div>
</div>
